import { vModelRadio } from "vue";
import { createStore } from "vuex";

export default createStore({
  state: {
    modal: false,
    modal2: false,
    loading: true,
},
getters: {
  modal: (state) => state.modal,
  modal2: (state) => state.modal2,
  loading: (state) => state.loading,
},
mutations: {
    TOGGLE_MODAL(state) {
        state.modal = !state.modal
    },
    TOGGLE_MODAL2(state) {
      state.modal2 = !state.modal2
    },
     TOGGLE_LOADING(state) {
      state.loading = !state.loading
    }
},
  actions: {},
  modules: {},
});
